import { Button, FCX } from "@datassential/platform-ui-lib";
import cn from "classnames";
import { IFoodProfileSummary } from "@models/NewFoodProfileSummary";
import { PermissionLevelEnum } from "@models/PermissionSection";
import SmallLoader from "@components/SmallLoader/SmallLoader";
import { IconDownloadOutline, IconPackages } from "@icons";
import useFoodProfileReportActions from "@pages/Food/refresh/hooks/useFoodProfileReportActions";
import "./FoodProfileSidebarActions.scss";

interface Props {
    summary: IFoodProfileSummary;
    isCollapsed: boolean;
}

/** DOWNLOAD + PACKAGE for the Food Profile sidebar. Collapsed, only a round Download button remains. */
const FoodProfileSidebarActions: FCX<Props> = ({ summary: { id, data }, isCollapsed }) => {
    // Without full Menu Trends access the summary carries placeholder data, so there is nothing real to export.
    const hasAccess = data.permissionLevel === PermissionLevelEnum.Full;
    const { download, addToPackage, isDownloading } = useFoodProfileReportActions(id, data.data.downloadLink);

    return (
        <div className={cn("FoodProfileSidebarActions", isCollapsed && "is-collapsed")}>
            <Button
                className="FoodProfileSidebarActions__button"
                onClick={download}
                isDisabled={!hasAccess || isDownloading}
                testId="buttonFoodSidebarDownload"
            >
                {isDownloading ? (
                    <span className="FoodProfileSidebarActions__loader"><SmallLoader/></span>
                ) : (
                    <IconDownloadOutline className="FoodProfileSidebarActions__icon"/>
                )}
                {/* Visually hidden when collapsed, so the icon-only button keeps its accessible name. */}
                <span className="FoodProfileSidebarActions__label">Download</span>
            </Button>
            {!isCollapsed && (
                <Button
                    className="FoodProfileSidebarActions__button"
                    onClick={addToPackage}
                    isDisabled={!hasAccess || id === null || id === undefined}
                    testId="buttonFoodSidebarAddToPackage"
                >
                    <IconPackages className="FoodProfileSidebarActions__icon is-package"/>
                    <span className="FoodProfileSidebarActions__label">Package</span>
                </Button>
            )}
        </div>
    );
};

export default FoodProfileSidebarActions;
